import { Apple, Play } from "lucide-react";
import { useAppPreferences } from "../../lib/preferences";
import { APP_DESTINATIONS } from "./app-destinations";
import "./onboarding.css";
import { storeOrder } from "./platform";

export function AppInstallLinks({ variant = "join" }: { variant?: "join" | "landing" }) {
  const { direction, t } = useAppPreferences();
  const actions = [
    {
      key: "android",
      href: APP_DESTINATIONS.googlePlay,
      label: t("onboarding.install.android"),
      Icon: Play,
    },
    {
      key: "ios",
      href: APP_DESTINATIONS.iosAppStore,
      label: t("onboarding.install.ios"),
      Icon: Apple,
    },
  ];
  // DOM order matches visual and keyboard order; iOS devices lead with Apple.
  const ordered = storeOrder() === "ios-first" ? [...actions].reverse() : actions;
  return (
    <div className={variant === "landing" ? "ld-hero-ctas" : "join-install-links"}>
      {ordered.map(({ Icon, href, key, label }) => (
        <a className={variant === "landing" ? "ld-btn ld-btn-lime ld-btn-lg join-install-landing" : "join-install join-install-store"} dir={direction} href={href} key={key}>
          <Icon aria-hidden="true" size={18} /> {label}
        </a>
      ))}
    </div>
  );
}
